import React, { useState, useEffect } from 'react';
import '../../css/administration.css'
import '../../components/layout/layout.css'
import BasicCard from '../../components/basics/cards/BasicCard'
import BasicReportSettings from './BasicReportSettings'
import BasicReportTable from './BasicReportTable'
import BasicReportDownload from './BasicReportDownload'
import './basicReport.css'

import { CommonAPIService } from "../../services/apis/CommonAPIService";
function BasicReport({ controllerName, pageTitle, excelFileName, hideTable, hasDownload, downloadConfig, tableConfig, usePagination }) {
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [pageConfig, setPageConfig] = useState({
        controllerName: controllerName,
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "",
    })
    const [downloadOptions, setDownloadOptions] = useState({})
    const [selectedDownloadItems, setSelectedDownloadItems] = useState([])
    const [filterArray, setFilterArray] = useState(0)
    const [error, setError] = useState("");

    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${controllerName}/PageSettings`)
            .then(data => {
                if (data != 0) {
                    setPageConfig({ ...pageConfig, ...{ pageSettings: data } })
                    setError(false)
                }
                else
                    setError(process.env.REACT_APP_USER_ERROR_MESSAGE);
                }
            )
            .catch(error => console.error(error));
    }, [pageConfig.apiName, controllerName]);

    useEffect(() => {
        setDownloadOptions({ hasDownload: hasDownload, selectedDownloadItems: selectedDownloadItems, setSelectedDownloadItems: setSelectedDownloadItems })
    }, [hasDownload, selectedDownloadItems])
   
    return (
        <BasicCard cardConfig={{ cardTitle: pageTitle, cardHeadingElement: 'h3' }}>
            {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
            <span className='basic-report-card'>
                <BasicReportSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} />
                {hideTable && hideTable === 'true' ? null : (
                    <BasicReportTable
                        pageConfig={pageConfig}
                        filterArray={filterArray}
                        downloadOptions={downloadOptions}
                        setUpdatingFilter={setUpdatingFilter}
                        usePagination={usePagination}
                    />
                )}
                <BasicReportDownload pageConfig={pageConfig} excelFileName={excelFileName} filterArray={filterArray} downloadConfig={downloadConfig} downloadItems={selectedDownloadItems} />
            </span>
        </BasicCard>
    )
}

export default BasicReport